import { env } from '$env/dynamic/public';
import { redirect } from '@sveltejs/kit';

export async function load({ params, url, fetch }) {
  //To test locally use the following url
  //Marketing Landing Pages: http://localhost:3003/{lpKey}/offer/offer-page-name
  //Regular customer Website: http://localhost:3003/{lpKey}/page-name
  const editorView = url.searchParams.get('editorView') === 'true';
  const previewMode = url.searchParams.get('previewMode') === 'true';

  let pageType = getPageType(params);
  let businessIdentifier = getBusinessIdentifier(url);
  let pageIdentifier = getPageIdentifier(url, params);

  //This console logs are needed for logging on grafana.
  console.log(pageType);
  console.log(businessIdentifier);
  console.log(pageIdentifier);

  const getPageUrl = `${env.PUBLIC_API_URL}/public/websitev2/${businessIdentifier}/pages/${pageIdentifier}/?websitePageType=${pageType}`;
  const getGeneralSettingsUrl = `${env.PUBLIC_API_URL}/public/websitev2/${businessIdentifier}/generalsettings/`;
  let getPageResponse, getGeneralSettingsResponse;
  try {
    getPageResponse = await fetch(getPageUrl)
      .then(res => res.json())
      .then(res => {
        if (res.data?.redirectUrl) {
          return {
            redirectUrl: res.data.redirectUrl,
          };
        }
        return res.data.landingPageModel;
      });
  } catch (e) {
    console.log('getPageResponseError', e);
  }

  //Redirect if there is a redirectUrl
  if (getPageResponse?.redirectUrl) {
    redirect(307, getPageResponse.redirectUrl + url.search);
  }

  //If getPageResponse is not valid, redirect to home
  if (!getPageResponse) {
    redirect(307, env.PUBLIC_MARKETING_WEBSITE_URL);
  }

  try {
    getGeneralSettingsResponse = await fetch(getGeneralSettingsUrl)
      .then(res => res.json())
      .then(res => res.data.generalSettings);
  } catch (e) {
    console.log('getGeneralSettingsResponseError', e);
  }

  return {
    editorView,
    previewMode,
    businessIdentifier,
    pageIdentifier,
    pageType: pageType,
    landingPageModel: editorView ? null : await getPageResponse,
    generalSettings: editorView ? null : await getGeneralSettingsResponse,
  };
}

function getPageType(params) {
  return params.catchall.includes('offer/') ? 'marketing' : 'default';
}

function getBusinessIdentifier(url) {
  const { host, hostname, pathname } = url;
  let businessIdentifier = hostname;
  //Get subdomain
  if (businessIdentifier.includes('.voolt.'))
    businessIdentifier = host.split('.')[0];

  //local test business name
  if (host.includes('localhost')) businessIdentifier = pathname.split('/')[1];

  //Custom domains, remove www
  if (businessIdentifier.includes('www.'))
    businessIdentifier = businessIdentifier.split('www.')[1];

  return businessIdentifier;
}

function getPageIdentifier(url, params) {
  const { host } = url;

  let pageIdentifier = 'home';

  //if no params provides safe to assume we need the home/index to render.
  if (params.catchall.length > 1) {
    pageIdentifier = params.catchall;
  } else {
    return 'home';
  }

  //get page name fallback
  if (pageIdentifier.includes('.js')) return 'home';

  //local test business name
  if (host.includes('localhost')) {
    pageIdentifier = pageIdentifier.includes('offer')
      ? pageIdentifier.split('/')[2]
      : pageIdentifier.split('/')[1] || 'home';
  } else {
    pageIdentifier = pageIdentifier.includes('offer')
      ? pageIdentifier.split('/')[1]
      : pageIdentifier.split('/')[0] || 'home';
  }

  // Final cleanup just in case
  return pageIdentifier.replace(/\//g, '');
}
